<!-- <div class="dialog-wrapper">
  <ng-template #customDialogHeaderTemplate>
    <div class="title-container">
      <h1>Session Expired</h1>
    </div>
  </ng-template>

  <ng-template #customDialogFooterTemplate>
    <div class="button-wrapper">
      <button
        id="contactFormSubmit"
        class="btn primary-btn"
        type="submit"
        (click)="refreshPage()"
      >
        LOGIN
      </button>
    </div>
  </ng-template>

  <pulse-dialog
    *ngIf="showRefreshDialogue"
    [styles]="style"
    [isModelOpen]="true"
    [headerTemplate]="customDialogHeaderTemplate"
    [footerTemplate]="customDialogFooterTemplate"
    (closeDialog)="refreshPage()"
  >
    <div class="modal-body font-bold">
      Your session is expired. Please login again.
    </div>
  </pulse-dialog>
</div> -->

<pulse-dialog
  *ngIf="isTimeout"
  [styles]="style"
  [isModelOpen]="true"
  [headerTitle]="'SESSION_TIMEOUT_WARNGIN' | translate"
  [footerTemplate]="customDialogFooterTemplate"
  class="user-inactive"
>
  <ng-template #customDialogHeaderTemplate>
    <div class="title-container">
      <h1>{{'SESSION_TIMEOUT_WARNGIN' | translate}}</h1>
    </div>
  </ng-template>

  <ng-template #customDialogFooterTemplate>
    <div class="button-wrapper">
      <button
        id="contactFormCancel"
        class="btn primary-btn"
        (click)="continueSession()"
      >
        {{'CONTINUE_SESSION' | translate}}
      </button>
      <button
        id="contactFormSubmit"
        class="btn ghost-btn ghost-default"
        type="submit"
        (click)="endSession()"
      >
        {{'END_SESSION' | translate}}
      </button>
    </div>
  </ng-template>
  <p> {{'YOUR_SESSION_EXPIRES_AUTOMATICALLY' | translate}} {{timer}} {{'SEC' | translate}}</p>

  <p> {{'SELECT_CONTINE_SESSION' | translate}}</p>
</pulse-dialog>